import { render, staticRenderFns } from "./TrainingCoursesTabInfo.vue?vue&type=template&id=67ee9f3a&"
import script from "./TrainingCoursesTabInfo.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesTabInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports